import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=6092b1a1"
import script from "./Splash.vue?vue&type=script&lang=ts"
export * from "./Splash.vue?vue&type=script&lang=ts"
import style0 from "./Splash.vue?vue&type=style&index=0&id=6092b1a1&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6092b1a1')) {
      api.createRecord('6092b1a1', component.options)
    } else {
      api.reload('6092b1a1', component.options)
    }
    module.hot.accept("./Splash.vue?vue&type=template&id=6092b1a1", function () {
      api.rerender('6092b1a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Splash.vue"
export default component.exports